export const STORAGE_KEYS = {
  travelDocument: 'travel-document',
  trip: 'trip',
  vehicle: 'vehicle',
  workTimeEntry: 'work-time-entry',
}
